import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "title", "icon"],
  _excluded2 = ["title", "icon", "content"],
  _excluded3 = ["type", "onClick", "title", "icon", "content"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/PromotionalBanner/PromotionalBanner.js",
  _this = this;
import React from 'react';
import { noop, testIdProps } from '../../helpers';
import { withTheme } from '../../core/ThemeProvider';
import MultilineTruncateParagraph from '../../core/components/MultilineTruncateParagraph';
import { BannerContainerVariant1, BannerContainerVariant2, ContentWrapper, ContentText, TitleVariant1, TitleVariant2, ContentBody, IconWrapper } from './style';
var bannerTypes = {
  VARIANT_1: 'variant1',
  VARIANT_2: 'variant2'
};
var Variant1 = function Variant1(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    Icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BannerContainerVariant1, _extends({
    onClick: onClick
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 3
    }
  }), /*#__PURE__*/React.createElement(ContentWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    color: rest.coreTheme.cl_white,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(ContentText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(TitleVariant1, {
    dangerouslySetInnerHTML: {
      __html: title
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 9
    }
  }))));
};
var Variant2 = function Variant2(_ref2) {
  var title = _ref2.title,
    Icon = _ref2.icon,
    content = _ref2.content,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(BannerContainerVariant2, _extends({}, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 3
    }
  }), /*#__PURE__*/React.createElement(ContentWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(IconWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    color: rest.coreTheme.cl_white,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(ContentText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(TitleVariant2, {
    dangerouslySetInnerHTML: {
      __html: title
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(MultilineTruncateParagraph, {
    numOfLines: 2,
    Typography: ContentBody,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, content))));
};
var PromotionalBanner = function PromotionalBanner(props) {
  var type = props.type,
    onClick = props.onClick,
    title = props.title,
    icon = props.icon,
    content = props.content,
    rest = _objectWithoutProperties(props, _excluded3);
  return type === bannerTypes.VARIANT_1 ? /*#__PURE__*/React.createElement(Variant1, _extends({}, rest, {
    title: title,
    icon: icon,
    onClick: onClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 5
    }
  })) : /*#__PURE__*/React.createElement(Variant2, _extends({}, rest, {
    title: title,
    icon: icon,
    content: content,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 5
    }
  }));
};
PromotionalBanner.defaultProps = {
  type: bannerTypes.VARIANT_1,
  onClick: noop
};
export default withTheme(PromotionalBanner);